export const documentCheckboxFormTestId = "components/fragments/forms/document-checkbox-form/DocumentCheckboxForm";

export const smilezemiGradeOptions: string[] = [
  "年小",
  "年中",
  "年長",
  "小学1年生",
  "小学2年生",
  "小学3年生",
  "小学4年生",
  "小学5年生",
  "小学6年生",
  "中学準備講座",
  "中学1年生",
  "中学2年生",
  "中学3年生",
];
